export default __webpack_public_path__ + "static/media/shareLogs.d31720c7.svg";